export const DIST_API_ENDPOINTS = {
    //Dashboard
    getUserBusiness: "/api/User/v1.0/getUserBusiness",
    getUserConfigSettings: "/api/Payment/getUserConfigSettings",
    dist_get_provider_list: "/api/Apitranxt/distributor/dist_get_provider_list",
    getDashboardData2: "/api/Payment/distributor/getDashboardData",
    getDashboardData3: "/api/Payment/distributor/v2.0/getDashboardData",
    fund_request_submit: "/api/Apitranxt/user/fund_request_submit",

    sendOtp: "/api/Payment/authentication/sendOtp",
    validateOtp: "/api/Payment/authentication/validateOtp",
    getDistributorUserBusinessReport: "/api/Admin/v1.0/getDistributorUserBusinessReport",
    updateCreditRequest: "/api/Admin/v1.0/updateCreditRequest",
    creditRequestReverseAmount: "/api/Admin/v1.0/creditRequestReverseAmount",

    getIntraFundTransfer: "/api/Admin/getIntraFundTransfer",
    creditRequestApprove: "/api/Payment/credit/creditRequestApprove",
    creditRequestReverseAmount1: "/api/Payment/credit/creditRequestReverseAmount",

    getDashboardData: "/api/Payment/distributor/getDashboardData",

    getAllCreditRequests: "//api/Payment/credit/v1.0/getAllCreditRequests",

    getAddReverseFundReport: "/api/Payment/v1.0/getAddReverseFundReport",
    dist_add_balance_retailer_new: "/api/Apitranxt/distributor/dist_add_balance_retailer_new",

    api_master_dist_reverse_balance: "/api/Apitranxt/api_master_dist_reverse_balance",
    salesMobileVerifySendOtp: "/api/Sales/salesMobileVerifySendOtp",
    salesMobileVerifyVerifyOtp: "/api/Sales/salesMobileVerifyVerifyOtp",

    dist_check_retailer: "/api/Apitranxt/distributor/dist_check_retailer",

    getloadbank: "/api/Apitranxt/getloadbank",

    dist_wallet_to_wallet_chk_number: "/api/Apitranxt/distributor/dist_wallet_to_wallet_chk_number",
    dist_wallet_to_wallet_submit: "/api/Apitranxt/distributor/dist_wallet_to_wallet_submit",
    walletToWalletReport: "/api/Payment/v1.0/walletToWalletReport",

    checkpassword: "/api/Apitranxt/checkpassword",

    dist_get_profit_report: "/api/Apitranxt/distributor/dist_get_profit_report",

    dist_get_retailer_report: "/api/Apitranxt/distributor/dist_get_retailer_report",
    dist_get_transaction_report: "/api/Apitranxt/distributor/dist_get_transaction_report",

    getWalletBalance: "/api/Payment/wallet/getWalletBalance",
    master_dist_profile_details: "/api/Apitranxt/master_dist_profile_details`",
    userFetchKycData: "/api/Payment/kyc/userFetchKycData",
    get_user_access_info: "/api/Apitranxt/user/get_user_access_info",

    check_session: "/api/Apitranxt/check_session",
    getUserConfigSettings: "//api/Payment/getUserConfigSettings",
  };
  